import React from "react";
import LineDivider from "rylak-common/src/components/divider/LineDivider";
import { translatePropertyValue } from "../../propertyCore";

export default function PropertyDescription(props) {
    const { selectedPropertyValue, propertyValues, showName = true, showLine = true } = props;

    const selectedProperty = propertyValues?.find(({ value }) => value === selectedPropertyValue);
    const selectedPropertyDescription = selectedProperty?.description;
    const propertyValueTranslated = selectedProperty && translatePropertyValue({ ...props, propertyValue: selectedProperty });

    return (
        <>
            {selectedPropertyDescription && (
                <div style={{ marginTop: "5px" }}>
                    {showLine && <LineDivider style={{ marginBottom: "5px" }} />}
                    {showName && (
                        <div
                            style={{
                                fontWeight: 500,
                                marginTop: "5px",
                                fontSize: "12px",
                            }}
                        >
                            {selectedProperty?.name || selectedProperty?.nameShort || propertyValueTranslated}
                        </div>
                    )}
                    <div style={{ fontSize: "12px" }}>{selectedPropertyDescription}</div>
                </div>
            )}
        </>
    );
}
